import { getViewingRegion } from '@/dataImplementation/viewingRegionWeb'
import { useGetStore } from '@/redux/hooks/hooks'
import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { getRedDataApiPaths } from '@vrw/data/src/config'
import { BrandDetails } from '@vrw/data/src/redux/rewards/types'
import { get } from '@vrw/data/src/utils/httpClient'
import { QueryParamsThatChangeReturnType } from '../query-type-helpers'

type UseBrandProps = {
  brandPath: string
} & Omit<UseQueryOptions<BrandDetails>, QueryParamsThatChangeReturnType>

const useBrand = ({ brandPath = '', ...restProps }: UseBrandProps) => {
  const viewingRegion = getViewingRegion()
  const isAuthenticated = useGetStore('auth.isAuthenticated')

  const { data: brand, ...rest } = useQuery({
    queryKey: ['band', brandPath, viewingRegion, isAuthenticated],
    queryFn: (): Promise<BrandDetails> =>
      get(
        `${getRedDataApiPaths().RED_API_DISCOVERY_BRANDS}${isAuthenticated ? '' : '/public'}/${brandPath}?viewingRegion=${viewingRegion}`,
        isAuthenticated
      ),
    ...restProps,
  })

  return { ...rest, brand }
}

export default useBrand
